// ============================================================================
// RECIPE MARKETPLACE
//
// Extracted from index.html. Loaded as <script type="text/babel" src="./recipes.js">.
// Defines: RecipesPage, RecipeDetailModal, RecipeOverview, RecipeSpec,
// RecipeMapping, RecipeDocs, RecipeInstallSummary, RecipeInstallWizard, shadeColor.
//
// Depends on: API, Spinner, AdapterIcon, fmtDate (defined in main script).
// React + marked are loaded as globals from CDN.
// ============================================================================

// `var`, not `const`: every text/babel script shares one global scope, so a second
// `const` binding of these names is a redeclaration SyntaxError now that Babel compiles
// JSX only (data-presets="react") instead of downlevelling to ES5.
var {useState,useEffect,useCallback,useRef,useMemo}=React;

const RECIPE_BRAND='#e91d41';
const RECIPE_BRAND_2='#ff5a6e';
const RECIPE_BRAND_TINT='rgba(233,29,65,.12)';
const RECIPE_BRAND_SOFT='rgba(233,29,65,.06)';

function truncateRecipeText(s, max){
  const t=String(s||'').trim();
  if(t.length<=max) return t;
  const cut=t.slice(0,max).replace(/\s+\S*$/,'');
  return (cut||t.slice(0,max)).trimEnd()+'…';
}
// Intentionally `var`, not `const` — shared global scope; see the note in index.html.
var TAXLAB_LIGHT_STYLE={
  fontFamily:'"Public Sans", sans-serif',
  fontWeight:600,
  fontSize:14,
  border:'1px solid rgb(196, 205, 213)',
  cursor:'pointer',
  opacity:1,
  borderRadius:10,
  padding:'9px 18px',
  display:'inline-flex',
  alignItems:'center',
  justifyContent:'center',
  gap:8,
  transition:'0.18s',
  whiteSpace:'nowrap',
  width:'auto',
  height:40,
  lineHeight:1.4,
  boxSizing:'border-box',
  background:'rgb(255, 255, 255)',
  color:'rgb(29, 37, 46)',
};
function RecipeIcon({kind='puzzle',size=18,color='currentColor'}){
  const common={width:size,height:size,viewBox:'0 0 24 24','aria-hidden':'true',style:{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}};
  switch(kind){
    case 'search':
      return <svg {...common}><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.9"></circle><path d="m16 16 4 4" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"></path></svg>;
    case 'book':
      return <svg {...common}><path fill="currentColor" d="M5 4h11a3 3 0 0 1 3 3v12H8a3 3 0 0 0-3 3z" opacity=".32"></path><path fill="currentColor" d="M8 4v15a3 3 0 0 0-3 3V7a3 3 0 0 1 3-3m3 5h5v1.5h-5zm0 3h5v1.5h-5z"></path></svg>;
    case 'spec':
      return <svg {...common}><path fill="currentColor" d="M4 5h16v14H4z" opacity=".28"></path><path fill="currentColor" d="M7 8h6v1.5H7zm0 3h10V13H7zm0 3h7v1.5H7zm11.2-7.2 1 1-3.9 3.9-1.7.2.2-1.7z"></path></svg>;
    case 'mapping':
      return <svg {...common}><circle cx="6" cy="7" r="2" fill="currentColor" opacity=".36"></circle><circle cx="18" cy="7" r="2" fill="currentColor" opacity=".36"></circle><circle cx="12" cy="17" r="2.4" fill="currentColor"></circle><path d="M8 7h8M7.2 8.2l3.2 6.2M16.8 8.2l-3.2 6.2" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"></path></svg>;
    case 'docs':
      return <svg {...common}><path fill="currentColor" d="M6 3h8l4 4v14H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" opacity=".3"></path><path fill="currentColor" d="M14 3v4h4M8 11h8v1.5H8zm0 3h8V15.5H8zm0 3h5V18.5H8z"></path></svg>;
    case 'install':
      return <svg {...common}><path fill="currentColor" d="M12 3v10.2l3.4-3.4 1.4 1.4-5.8 5.8-5.8-5.8 1.4-1.4 3.4 3.4V3z"></path><path fill="currentColor" d="M4 19h16v2H4z" opacity=".36"></path></svg>;
    case 'plug':
      return <svg {...common}><path fill="currentColor" d="M7 3h2v4h6V3h2v4h1a1 1 0 0 1 1 1v3a5 5 0 0 1-5 5h-1v4h-2v-4h-1a5 5 0 0 1-5-5V8a1 1 0 0 1 1-1h1z" opacity=".32"></path><path fill="currentColor" d="M8 9h8v2a4 4 0 0 1-8 0z"></path></svg>;
    case 'flow':
      return <svg {...common}><circle cx="5.5" cy="7" r="2.5" fill="currentColor" opacity=".34"></circle><circle cx="18.5" cy="7" r="2.5" fill="currentColor" opacity=".34"></circle><circle cx="12" cy="17" r="2.6" fill="currentColor"></circle><path d="M8 8.5h8M7.5 9.6 10.6 14M16.5 9.6 13.4 14" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path></svg>;
    case 'lookup':
      return <svg {...common}><path fill="currentColor" d="M4 4h16v16H4z" opacity=".28"></path><path fill="currentColor" d="M7 8h10v1.5H7zm0 3h8V12.5H7zm0 3h6V15.5H7z"></path></svg>;
    case 'link':
      return <svg {...common}><path fill="currentColor" d="M10.8 13.2a3.5 3.5 0 0 1 0-5l2.4-2.4a3.5 3.5 0 1 1 5 5l-1.2 1.2" opacity=".35"></path><path fill="currentColor" d="M13.2 10.8a3.5 3.5 0 0 1 0 5l-2.4 2.4a3.5 3.5 0 0 1-5-5l1.2-1.2"></path></svg>;
    case 'tag':
      return <svg {...common}><path fill="currentColor" d="M3 10.5 10.5 3H19a2 2 0 0 1 2 2v8.5L13.5 21z" opacity=".3"></path><circle cx="16.2" cy="7.8" r="1.4" fill="currentColor"></circle></svg>;
    case 'compat':
      return <svg {...common}><circle cx="12" cy="12" r="9" fill="currentColor" opacity=".3"></circle><path d="m8.6 12.2 2.2 2.2 4.6-4.6" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"></path></svg>;
    case 'clock':
      return <svg {...common}><circle cx="12" cy="12" r="9" fill="currentColor" opacity=".3"></circle><path d="M12 7.5v5l3 2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"></path></svg>;
    case 'calendar':
      return <svg {...common}><rect x="4" y="5" width="16" height="15" rx="2" fill="currentColor" opacity=".3"></rect><path fill="currentColor" d="M8 3h1.6v3H8zm6.4 0H16v3h-1.6zM7 10h10v1.5H7zm0 3h7v1.5H7z"></path></svg>;
    case 'folder':
      return <svg {...common}><path fill="currentColor" d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v1H3z" opacity=".32"></path><path fill="currentColor" d="M3 10h18l-1.2 7.2A2 2 0 0 1 17.8 19H6.2a2 2 0 0 1-2-1.8z"></path></svg>;
    case 'rocket':
      return <svg {...common}><path fill="currentColor" d="M14.5 4.5c-2 0-4 1-5.4 2.4L6 10l4 1 1 4 3.1-3.1c1.4-1.4 2.4-3.4 2.4-5.4V4.5z" opacity=".35"></path><path fill="currentColor" d="m6 10-2.5 2.5a1 1 0 0 0 .7 1.7H6zm5 5v1.8a1 1 0 0 1-1.7.7L6.8 15z"></path></svg>;
    case 'erp':
      return <svg {...common}><path fill="currentColor" d="M4.5 21V7.6L12 3.2l7.5 4.4V21z" opacity=".32"></path><path fill="currentColor" d="M6.8 9.1h2.2v2H6.8zm3.4 0h2.2v2h-2.2zm3.4 0h2.2v2h-2.2zM6.8 12.3h2.2v2H6.8zm3.4 0h2.2v2h-2.2zm3.4 0h2.2v2h-2.2zM10.2 16.4h3.6V21h-3.6z"></path></svg>;
    case 'reuse':
      return <svg {...common}><path fill="currentColor" d="M6.2 8.2H3l3-3 3 3H7.8a4.2 4.2 0 0 1 7.8 2h-1.8A2.4 2.4 0 0 0 9.3 8.9zM17.8 15.8H21l-3 3-3-3h1.2a4.2 4.2 0 0 1-7.8-2h1.8a2.4 2.4 0 0 0 4.5 1.3z"></path></svg>;
    case 'spark':
      return <svg {...common}><path fill="currentColor" d="m12 3 1.4 3.6L17 8l-3.6 1.4L12 13l-1.4-3.6L7 8l3.6-1.4zm6.5 9.5.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8zm-13 2 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"></path></svg>;
    case 'eye':
      return <svg {...common}><path fill="currentColor" d="M12 6.5c4.91 0 8.91 3.19 10.3 5.5c-1.39 2.31-5.39 5.5-10.3 5.5S3.09 14.31 1.7 12c1.39-2.31 5.39-5.5 10.3-5.5" opacity=".3"></path><circle cx="12" cy="12" r="2.65" fill="currentColor"></circle></svg>;
    case 'eyeOff':
      return <svg {...common}><path fill="currentColor" d="M12 6.5c4.91 0 8.91 3.19 10.3 5.5c-1.39 2.31-5.39 5.5-10.3 5.5S3.09 14.31 1.7 12c1.39-2.31 5.39-5.5 10.3-5.5" opacity=".3"></path><circle cx="12" cy="12" r="2.65" fill="currentColor"></circle><path fill="currentColor" d="m4.53 4.53l14.94 14.94l-1.06 1.06L3.47 5.59z"></path></svg>;
    case 'close':
      return <svg {...common}><circle cx="12" cy="12" r="10" fill="currentColor" opacity=".14"></circle><path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" d="m8.5 8.5 7 7m0-7-7 7"></path></svg>;
    default:
      return <svg {...common}><path fill="currentColor" d="M9.5 3a2 2 0 0 0-2 2v2.2H5.3a2 2 0 0 0-2 2v2.6a2 2 0 0 0 2 2h2.2V18a2 2 0 0 0 2 2h2.6a2 2 0 0 0 2-2v-2.2h2.2a2 2 0 0 0 2-2V9.2a2 2 0 0 0-2-2h-2.2V5a2 2 0 0 0-2-2z" opacity=".35"></path><path fill="currentColor" d="M10.8 8h2.4v2.4h2.4v2.4h-2.4v2.4h-2.4v-2.4H8.4v-2.4h2.4z"></path></svg>;
  }
}
function recipeKindFromCategory(category){
  const c=String(category||'').toLowerCase();
  if(c.includes('finance')||c.includes('invoice'))return 'flow';
  if(c.includes('api')||c.includes('protocol'))return 'link';
  if(c.includes('data')||c.includes('mapping'))return 'mapping';
  if(c.includes('docs'))return 'docs';
  return 'puzzle';
}

function RecipesPage({showToast, goToIntegrations}){
  const [recipes,setRecipes]=useState([]);
  const [loading,setLoading]=useState(true);
  const [searchQ,setSearchQ]=useState('');
  const [filterCat,setFilterCat]=useState('');
  const [opening,setOpening]=useState(null); // recipe id being opened (full fetch)
  const [openRecipe,setOpenRecipe]=useState(null);

  const load=useCallback(async()=>{
    try{setLoading(true);const d=await API('GET','/api/recipes');setRecipes(Array.isArray(d)?d:[]);}
    catch(e){showToast('Failed to load accelerators: '+e.message,'error');}
    finally{setLoading(false);}
  },[showToast]);
  useEffect(()=>{load();},[load]);

  const open=async(r)=>{
    setOpening(r.id);
    try{
      const full=await API('GET','/api/recipes/'+r.id);
      setOpenRecipe(full);
    }catch(e){showToast('Failed to open accelerator: '+e.message,'error');}
    finally{setOpening(null);}
  };

  const cats=Array.from(new Set(recipes.map(r=>r.category).filter(Boolean))).sort();

  const filtered=recipes.filter(r=>{
    const q=searchQ.toLowerCase();
    if(q && !((r.name||'').toLowerCase().includes(q) || (r.tagline||'').toLowerCase().includes(q) || (r.tags||[]).some(t=>t.toLowerCase().includes(q)))) return false;
    if(filterCat && r.category!==filterCat) return false;
    return true;
  });

  return(
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Accelerators</h1>
          <div className="page-subtitle">Pre-built integration accelerators · install in minutes, edit anything in the designer afterwards</div>
        </div>
      </div>

      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:20,flexWrap:'wrap'}}>
        <div className="search-field" style={{width:300,flex:'0 0 auto'}}>
          <span className="search-field-icon"><RecipeIcon kind="search" size={20} color="rgb(99,115,129)"/></span>
          <input className="search-field-input" placeholder="Search accelerators by name, tagline, tag…" value={searchQ} onChange={e=>setSearchQ(e.target.value)}/>
        </div>
        <select className="form-select" style={{maxWidth:200,flex:'0 0 auto'}} value={filterCat} onChange={e=>setFilterCat(e.target.value)}>
          <option value="">All Categories</option>
          {cats.map(c=><option key={c} value={c}>{c}</option>)}
        </select>
        <button className="btn btn-refresh" onClick={load} style={{...TAXLAB_LIGHT_STYLE,flexShrink:0}}><BuilderRefreshIcon size={18}/> Refresh</button>
        <div style={{flex:1}}/>
        <span style={{fontSize:12,color:'var(--text3)'}}>{filtered.length} accelerator{filtered.length!==1?'s':''}</span>
      </div>

      {loading?<div style={{textAlign:'center',padding:40,color:'var(--text2)'}}>Loading accelerators…</div>:
       filtered.length===0?
        <div className="empty-state">
          <div className="empty-icon" style={{background:RECIPE_BRAND_TINT,color:RECIPE_BRAND}}><RecipeIcon kind="puzzle" size={24} color="currentColor"/></div>
          <p style={{marginBottom:16}}>{recipes.length===0?'No accelerators are shipped in this build.':'No accelerators match your filter.'}</p>
        </div>:
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill, minmax(310px, 1fr))',gap:14}}>
          {filtered.map(r=>{
            // Identify the two endpoints the recipe connects (source + target)
            // so we can render real adapter logos instead of a generic emoji.
            const slots=r.connections||[];
            const src=slots.find(s=>s.slot==='source'||s.slot==='erp')||slots[0];
            const tgt=slots.find(s=>s.slot==='target'||s.slot==='asp')||slots[1];
            return(
              <div key={r.id} className="recipe-card" onClick={()=>open(r)}>
                <div className="accent-bar" style={{background:'linear-gradient(90deg, #e91d41 0%, #ff5a6e 100%)'}}/>
                <div className="recipe-card-header">
                  <div className="recipe-card-icon" style={{background:RECIPE_BRAND_TINT,color:RECIPE_BRAND}}><RecipeIcon kind="erp" size={28} color={RECIPE_BRAND}/></div>
                  <div style={{flex:1,minWidth:0}}>
                    <div className="recipe-card-title">{r.name}</div>
                    <div className="recipe-card-publisher">by {r.publisher||'TaxLab'} · v{r.version||'1.0.0'}</div>
                  </div>
                  {opening===r.id && <Spinner/>}
                </div>
                {/* Source → target visualization with real adapter logos */}
                {(src||tgt)&&(
                  <div className="recipe-card-flow">
                    {src && (
                      <div className="recipe-card-flow-side" title={src.label}>
                        <AdapterIcon id={src.adapter} size={26}/>
                        <div className="label">
                          <span className="role">Source</span>
                          <span className="name">{(ADAPTERS[src.adapter]||{}).label||src.label||src.adapter}</span>
                        </div>
                      </div>
                    )}
                    <div className="recipe-card-flow-arrow">→</div>
                    {tgt && (
                      <div className="recipe-card-flow-side" title={tgt.label} style={{justifyContent:'flex-end'}}>
                        <div className="label" style={{textAlign:'right'}}>
                          <span className="role">Target</span>
                          <span className="name">{(ADAPTERS[tgt.adapter]||{}).label||tgt.label||tgt.adapter}</span>
                        </div>
                        <AdapterIcon id={tgt.adapter} size={26}/>
                      </div>
                    )}
                  </div>
                )}
                <div className="recipe-card-tagline" title={r.tagline||''}>{truncateRecipeText(r.tagline, 90)}</div>
                <div className="recipe-card-footer">
                  {r.category && <span className="recipe-tag recipe-tag-cat" style={{background:RECIPE_BRAND_TINT,color:RECIPE_BRAND,borderColor:'rgba(233,29,65,.32)'}}>{r.category}</span>}
                  {(r.tags||[]).slice(0,3).map(t=><span key={t} className="recipe-tag">{t}</span>)}
                  {(r.tags||[]).length>3 && <span className="recipe-tag">+{r.tags.length-3}</span>}
                </div>
              </div>
            );
          })}
        </div>
      }

      {openRecipe&&<RecipeDetailModal
        recipe={openRecipe}
        onClose={()=>setOpenRecipe(null)}
        onInstalled={(installRes)=>{
          setOpenRecipe(null);
          showToast(`Installed ${installRes.integrationIds.length} integration · open Integrations to activate`,'success');
          if(goToIntegrations) goToIntegrations();
        }}
        showToast={showToast}
      />}
    </div>
  );
}

/* ── RECIPE DETAIL MODAL ──────────────────────────────────────────────────
 * Tabs: Overview · Spec · Mapping · Documentation · Install
 */
function RecipeDetailModal({recipe, onClose, onInstalled, showToast}){
  const [tab,setTab]=useState('overview');
  const [docKey,setDocKey]=useState('overview'); // active markdown key inside Documentation tab
  const [docBody,setDocBody]=useState('');
  const [docLoading,setDocLoading]=useState(false);
  const [mapping,setMapping]=useState(null);
  const [mappingLoading,setMappingLoading]=useState(false);
  const [installCount,setInstallCount]=useState(null);
  const [installations,setInstallations]=useState([]);
  const [showInstallWizard,setShowInstallWizard]=useState(false);

  // Load installations count once
  useEffect(()=>{
    let alive=true;
    API('GET',`/api/recipes/${recipe.id}/installations`).then(r=>{
      if(!alive)return;
      setInstallCount(r.count||0);
      setInstallations(r.installations||[]);
    }).catch(()=>{});
    return()=>{alive=false;};
  },[recipe.id]);

  // Lazy-load mapping when Mapping tab opens
  useEffect(()=>{
    if(tab!=='mapping' || mapping) return;
    setMappingLoading(true);
    API('GET',`/api/recipes/${recipe.id}/mapping`)
      .then(m=>setMapping(m))
      .catch(e=>showToast('Failed to load mapping: '+e.message,'error'))
      .finally(()=>setMappingLoading(false));
  },[tab, recipe.id, mapping, showToast]);

  // Load doc body when entering Docs tab or switching doc key.
  // Cache-bust with the recipe version so a v1.0→v1.1 reinstall always
  // serves fresh markdown. Surface the real status code on failure so the
  // user sees "404 Not Found" instead of a generic "Failed to fetch".
  useEffect(()=>{
    if(tab!=='docs' || !recipe.id) return;
    let alive=true;
    setDocLoading(true);
    const url=`/api/recipes/${encodeURIComponent(recipe.id)}/docs/${encodeURIComponent(docKey)}?v=${encodeURIComponent(recipe.version||'')}`;
    fetch(url, {cache:'no-store', headers:{'Accept':'text/markdown, text/plain, */*'}})
      .then(async r=>{
        if(!r.ok){
          let detail=''; try{ detail=await r.text(); }catch{}
          throw new Error(`HTTP ${r.status} ${r.statusText}${detail?' — '+detail.slice(0,200):''}`);
        }
        return r.text();
      })
      .then(t=>{ if(alive) setDocBody(t); })
      .catch(e=>{ if(alive) setDocBody(`# Could not load \`${docKey}\`\n\n**${e.message||e}**\n\nIf this persists, hard-refresh the browser (Ctrl+Shift+R) to clear the cached UI bundle.`); })
      .finally(()=>{ if(alive) setDocLoading(false); });
    return ()=>{ alive=false; };
  },[tab, docKey, recipe.id, recipe.version]);

  const accent=RECIPE_BRAND;
  const tabCounts = {
    spec: Object.keys(recipe.specs||{}).length || null,
    mapping: mapping ? (mapping.groups||[]).reduce((s,g)=>s+(g.fields||[]).length,0) : null,
    docs: Object.keys(recipe.docs||{}).length || null,
  };

  return(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content recipe-modal" onClick={e=>e.stopPropagation()}
        style={{'--accent-color':RECIPE_BRAND,'--accent-tint':RECIPE_BRAND_SOFT}}>

        {/* HERO */}
        <div className="recipe-hero" style={{background:'#e91d41'}}>
          <div className="recipe-hero-row">
            <div className="recipe-hero-icon"><RecipeIcon kind="erp" size={40} color="#fff"/></div>
            <div className="recipe-hero-meta">
              <div className="recipe-hero-eyebrow">
                {recipe.category||'Accelerator'}{recipe.subcategory?' · '+recipe.subcategory:''}
              </div>
              <div className="recipe-hero-title">{recipe.name}</div>
              <div className="recipe-hero-tagline">{recipe.tagline}</div>
              <div className="recipe-hero-meta-row">
                <span className="recipe-hero-chip">v{recipe.version}</span>
                <span className="recipe-hero-chip">by {recipe.publisher||'TaxLab'}</span>
                {recipe.publishedAt && <span className="recipe-hero-chip"><RecipeIcon kind="calendar" size={12}/> {recipe.publishedAt}</span>}
                {installCount>0 && <span className="recipe-hero-chip installed"><RecipeIcon kind="compat" size={12}/> {installCount} installed</span>}
              </div>
            </div>
            <div className="recipe-hero-actions">
              <button className="recipe-cta" onClick={()=>setShowInstallWizard(true)}>
                <RecipeIcon kind="install" size={14}/>
                <span>{installCount>0?'Install Again':'Install Accelerator'}</span>
              </button>
              <button className="recipe-hero-close" onClick={onClose} aria-label="Close"><CloseIcon size={16} color="#fff"/></button>
            </div>
          </div>
        </div>

        {/* TABS */}
        <div className="recipe-detail-tabs">
          {[
            {id:'overview',label:'Overview',icon:<RecipeIcon kind="book" size={18}/>},
            {id:'spec',label:'Spec',icon:<RecipeIcon kind="spec" size={18}/>,count:tabCounts.spec},
            {id:'mapping',label:'Mapping',icon:<RecipeIcon kind="mapping" size={18}/>,count:tabCounts.mapping},
            {id:'docs',label:'Documentation',icon:<RecipeIcon kind="docs" size={18}/>,count:tabCounts.docs},
            {id:'install',label:'Install',icon:<RecipeIcon kind="install" size={18}/>}
          ].map(t=>(
            <button key={t.id} className={`recipe-detail-tab${tab===t.id?' active':''}`} onClick={()=>setTab(t.id)}>
              <span style={{display:'inline-flex'}}>{t.icon}</span>
              <span>{t.label}</span>
              {t.count!=null && <span className="tab-count">{t.count}</span>}
            </button>
          ))}
        </div>

        {/* BODY */}
        <div className="recipe-modal-body">
          <div className="recipe-modal-body-inner">
            {tab==='overview' && <RecipeOverview recipe={recipe} installations={installations} accent={accent}/>}
            {tab==='spec' && <RecipeSpec recipe={recipe}/>}
            {tab==='mapping' && (mappingLoading?<div style={{textAlign:'center',padding:60,color:'var(--text2)'}}>Loading mapping…</div>:<RecipeMapping mapping={mapping}/>)}
            {tab==='docs' && <RecipeDocs recipe={recipe} docKey={docKey} setDocKey={setDocKey} docBody={docBody} docLoading={docLoading}/>}
            {tab==='install' && <RecipeInstallSummary recipe={recipe} onLaunch={()=>setShowInstallWizard(true)} accent={accent}/>}
          </div>
        </div>

        {showInstallWizard && <RecipeInstallWizard
          recipe={recipe}
          onClose={()=>setShowInstallWizard(false)}
          onInstalled={onInstalled}
          showToast={showToast}
        />}
      </div>
    </div>
  );
}

/** Tints/shades a hex color by `percent` (-100..100). Used to build a single
 *  diagonal gradient from the recipe's accent color into a darker stop. */
function shadeColor(hex, percent){
  if (!hex || hex[0]!=='#') return hex;
  const f=parseInt(hex.slice(1),16);
  const t=percent<0?0:255;
  const p=Math.abs(percent)/100;
  const R=f>>16, G=f>>8&0x00FF, B=f&0x0000FF;
  const r=Math.round((t-R)*p)+R;
  const g=Math.round((t-G)*p)+G;
  const b=Math.round((t-B)*p)+B;
  return '#'+(0x1000000 + (r<<16) + (g<<8) + b).toString(16).slice(1);
}

/* ── Recipe Overview tab ── */
function RecipeOverview({recipe, installations, accent=RECIPE_BRAND}){
  const conns=(recipe.connections||[]);
  const intgs=(recipe.integrations||[]);
  const lookups=(recipe.lookups||[]);

  return(
    <div style={{display:'grid',gridTemplateColumns:'minmax(0, 1fr) 320px',gap:22,alignItems:'flex-start'}}>
      {/* LEFT — main content */}
      <div>
        {/* What it does */}
        <div className="r-card" style={{marginBottom:16}}>
          <div className="r-card-pad">
            <div className="r-section-title" style={{display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="book" size={14}/> What it does</div>
            <div style={{fontSize:13.5,color:'var(--text2)',lineHeight:1.65}}>{recipe.useCase || recipe.tagline}</div>
          </div>
        </div>

        {/* What gets created — visual cards */}
        <div style={{marginBottom:18}}>
          <div className="r-section-title" style={{display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="install" size={14}/> What gets created on install</div>
          <div className="artefact-grid">
            <div className="artefact-card">
              <div className="artefact-icon" style={{background:'rgba(8,145,178,.12)',color:'#0891b2'}}><RecipeIcon kind="plug" size={16} color="#0891b2"/></div>
              <div className="artefact-meta">
                <div className="artefact-count-row">
                  <span className="artefact-count">{conns.length}</span>
                  <span className="artefact-label">Connection{conns.length!==1?'s':''}</span>
                </div>
                <div className="artefact-detail">{conns.map(c=>c.label).join(' · ')||'—'}</div>
              </div>
            </div>
            <div className="artefact-card">
              <div className="artefact-icon" style={{background:RECIPE_BRAND_TINT,color:RECIPE_BRAND}}><RecipeIcon kind="flow" size={16} color={RECIPE_BRAND}/></div>
              <div className="artefact-meta">
                <div className="artefact-count-row">
                  <span className="artefact-count">{intgs.length}</span>
                  <span className="artefact-label">Integration{intgs.length!==1?'s':''}</span>
                </div>
                <div className="artefact-detail">{intgs.map(i=>i.name).join(' · ')||'—'}</div>
              </div>
            </div>
            <div className="artefact-card">
              <div className="artefact-icon" style={{background:'rgba(245,158,11,.14)',color:'#d97706'}}><RecipeIcon kind="lookup" size={16} color="#d97706"/></div>
              <div className="artefact-meta">
                <div className="artefact-count-row">
                  <span className="artefact-count">{lookups.length}</span>
                  <span className="artefact-label">Lookup{lookups.length!==1?'s':''}</span>
                </div>
                <div className="artefact-detail">{lookups.map(l=>l.name).join(' · ')||'—'}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Connections required */}
        <div style={{marginBottom:18}}>
          <div className="r-section-title" style={{display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="link" size={14}/> Connections required</div>
          {conns.map(slot=>(
            <div key={slot.slot} className="slot-card">
              <div className="slot-icon"><RecipeIcon kind="plug" size={14} color="currentColor"/></div>
              <div className="slot-meta">
                <div className="slot-title">
                  {slot.label}
                  <span className="slot-adapter-pill">{slot.adapter}</span>
                  {slot.required && <span style={{fontSize:10,fontWeight:700,color:'#dc2626'}}>* required</span>}
                </div>
                <div className="slot-desc">{slot.description}</div>
                {slot.fieldsHint && <div className="slot-hint">{slot.fieldsHint}</div>}
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* RIGHT — info rail */}
      <div style={{position:'sticky',top:16}}>
        <div className="info-card">
          <div className="info-card-key" style={{display:'inline-flex',alignItems:'center',gap:6}}><RecipeIcon kind="tag" size={12}/> Tags</div>
          <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
            {(recipe.tags||[]).length===0 && <span style={{fontSize:11.5,color:'var(--text3)'}}>—</span>}
            {(recipe.tags||[]).map(t=><span key={t} className="recipe-tag">{t}</span>)}
          </div>
        </div>

        {recipe.compatibility && (
          <div className="info-card">
            <div className="info-card-key" style={{display:'inline-flex',alignItems:'center',gap:6}}><RecipeIcon kind="compat" size={12}/> Compatibility</div>
            {Object.entries(recipe.compatibility).map(([k,arr])=>(
              <div key={k} className="info-row">
                <span className="k">{k}</span>
                <span className="v">{Array.isArray(arr)?arr.join(', '):String(arr)}</span>
              </div>
            ))}
          </div>
        )}

        <div className="info-card">
          <div className="info-card-key" style={{display:'inline-flex',alignItems:'center',gap:6}}><RecipeIcon kind="clock" size={12}/> Schedule</div>
          <div style={{fontSize:12.5,color:'var(--text)',marginBottom:6}}>
            <strong>Default:</strong> {(recipe.schedule||{}).displayDefault || '—'}
          </div>
          {(recipe.schedule||{}).defaultCron && <div className="code-block">{recipe.schedule.defaultCron}</div>}
          <div style={{fontSize:11,color:'var(--text3)',marginTop:8}}>
            {(recipe.schedule||{}).configurable ? 'Configurable during install' : 'Fixed schedule'}
          </div>
        </div>

        {installations.length>0 && (
          <div className="info-card" style={{borderColor:'rgba(22,163,74,.3)',background:'rgba(22,163,74,.04)'}}>
            <div className="info-card-key" style={{color:'#15803d'}}>● Already installed ({installations.length})</div>
            {installations.map(i=>(
              <div key={i.id} style={{padding:'7px 0',borderBottom:'1px solid var(--border)'}}>
                <div style={{fontWeight:600,fontSize:12.5}}>{i.name}</div>
                <div style={{fontSize:11,color:'var(--text3)',marginTop:2}}>{i.status} · v{i.recipeVersion}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Recipe Spec tab ── */
function RecipeSpec({recipe}){
  const items=Object.entries(recipe.specs||{});
  return(
    <div>
      <div className="r-card" style={{background:`linear-gradient(135deg, ${RECIPE_BRAND_SOFT}, rgba(233,29,65,.03))`,borderColor:'rgba(233,29,65,.22)',marginBottom:18}}>
        <div className="r-card-pad">
          <div className="r-section-title" style={{color:RECIPE_BRAND,marginBottom:6,display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="spec" size={14} color={RECIPE_BRAND}/> Authoritative specifications</div>
          <div style={{fontSize:13,color:'var(--text2)',lineHeight:1.6}}>The exact API endpoints, schemas, protocols and authentication patterns this accelerator operates against. Use this to confirm the accelerator matches your environment before installing.</div>
        </div>
      </div>

      <div className="spec-card">
        {items.length===0?<div style={{padding:'14px 0',color:'var(--text3)',fontSize:13}}>No specs documented for this accelerator.</div>:
          items.map(([k,v])=>(
            <div key={k} className="spec-item">
              <div className="spec-key">{k.replace(/([A-Z])/g,' $1').replace(/^./,c=>c.toUpperCase())}</div>
              <div className="spec-val">{String(v)}</div>
            </div>
          ))
        }
      </div>

      <div style={{marginTop:24}}>
        <div className="r-section-title" style={{fontSize:14,marginBottom:10,display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="flow" size={14} color={RECIPE_BRAND}/> Integrations bundled in this accelerator</div>
        {(recipe.integrations||[]).map(intg=>(
          <div key={intg.templateId} className="r-card" style={{marginBottom:10}}>
            <div className="r-card-pad" style={{padding:'14px 16px'}}>
              <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
                <div style={{width:32,height:32,borderRadius:9,background:RECIPE_BRAND_TINT,color:RECIPE_BRAND,display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0}}><RecipeIcon kind="flow" size={15} color={RECIPE_BRAND}/></div>
                <span style={{fontWeight:700,fontSize:14}}>{intg.name}</span>
                <span className="recipe-tag recipe-tag-cat">{intg.triggerType}</span>
                {intg.category && <span className="recipe-tag">{intg.category}</span>}
              </div>
              <div style={{fontSize:12.5,color:'var(--text2)',marginTop:8,lineHeight:1.55}}>{intg.description}</div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:10,display:'flex',gap:14,flexWrap:'wrap'}}>
                <span><strong style={{color:'var(--text2)'}}>Flow:</strong> <code style={{fontFamily:'ui-monospace,monospace'}}>{intg.sourceSlot}</code> → <code style={{fontFamily:'ui-monospace,monospace'}}>{intg.targetSlot}</code></span>
                <span><strong style={{color:'var(--text2)'}}>Route:</strong> <code style={{fontFamily:'ui-monospace,monospace'}}>{intg.routeFile}</code></span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Recipe Mapping tab — the field-by-field source→target view ── */
function RecipeMapping({mapping}){
  if(!mapping) return <div style={{textAlign:'center',padding:40,color:'var(--text3)'}}>No mapping document.</div>;

  // Pre-compute counts so users can see the scope at a glance and each row
  // gets a stable global serial alongside its per-group serial.
  const groups = mapping.groups || [];
  const totalFields = groups.reduce((s,g)=>s+(g.fields||[]).length, 0);
  const totalRequired = groups.reduce((s,g)=>s+(g.fields||[]).filter(f=>f.targetCard && f.targetCard.startsWith('1')).length, 0);
  // Running offset per group → first global serial for that group's first row
  const groupOffsets = [];
  groups.reduce((acc,g)=>{ groupOffsets.push(acc); return acc + (g.fields||[]).length; }, 0);

  return(
    <div>
      <div style={{padding:'14px 18px',background:`linear-gradient(135deg,rgba(8,145,178,.06),${RECIPE_BRAND_SOFT})`,border:'1px solid rgba(233,29,65,.22)',borderRadius:10,marginBottom:18}}>
        <div style={{fontSize:14,fontWeight:700,color:'var(--text)'}}>{mapping.title}</div>
        <div style={{fontSize:12,color:'var(--text2)',marginTop:5,lineHeight:1.55}}>{mapping.summary}</div>

        {/* Headline counts so the user sees the scope before diving into rows. */}
        <div style={{display:'flex',gap:8,marginTop:12,flexWrap:'wrap'}}>
          <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'4px 10px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:999,fontSize:11.5,fontWeight:600,color:'var(--text)'}}>
            <span style={{fontSize:14,fontWeight:800,color:RECIPE_BRAND}}>{totalFields}</span>
            <span style={{color:'var(--text3)'}}>fields mapped</span>
          </span>
          <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'4px 10px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:999,fontSize:11.5,fontWeight:600,color:'var(--text)'}}>
            <span style={{fontSize:14,fontWeight:800,color:'#dc2626'}}>{totalRequired}</span>
            <span style={{color:'var(--text3)'}}>required (1..N)</span>
          </span>
          <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'4px 10px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:999,fontSize:11.5,fontWeight:600,color:'var(--text)'}}>
            <span style={{fontSize:14,fontWeight:800,color:'#0891b2'}}>{groups.length}</span>
            <span style={{color:'var(--text3)'}}>groups</span>
          </span>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginTop:14}}>
          {mapping.sourceSystem && (
            <div style={{padding:'10px 12px',background:'rgba(8,145,178,.08)',border:'1px solid rgba(8,145,178,.25)',borderRadius:8}}>
              <div style={{fontSize:10.5,fontWeight:700,color:'#0891b2',textTransform:'uppercase',letterSpacing:'.5px'}}>Source System</div>
              <div style={{fontWeight:700,fontSize:13.5,marginTop:3}}>{mapping.sourceSystem.name}</div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:2,fontFamily:'ui-monospace,monospace'}}>{mapping.sourceSystem.api}</div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:1,fontFamily:'ui-monospace,monospace',wordBreak:'break-word'}}>{mapping.sourceSystem.resource}</div>
            </div>
          )}
          {mapping.targetSystem && (
            <div style={{padding:'10px 12px',background:'rgba(22,163,74,.08)',border:'1px solid rgba(22,163,74,.25)',borderRadius:8}}>
              <div style={{fontSize:10.5,fontWeight:700,color:'#15803d',textTransform:'uppercase',letterSpacing:'.5px'}}>Target System</div>
              <div style={{fontWeight:700,fontSize:13.5,marginTop:3}}>{mapping.targetSystem.name}</div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:2,fontFamily:'ui-monospace,monospace'}}>{mapping.targetSystem.format}</div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:1,fontFamily:'ui-monospace,monospace',wordBreak:'break-word'}}>{mapping.targetSystem.namespace}</div>
            </div>
          )}
        </div>

        {mapping.specVersion && <div style={{fontSize:11,color:'var(--text3)',marginTop:10}}>Spec: <strong>{mapping.specVersion}</strong>{mapping.specUrl && <> · <a href={mapping.specUrl} target="_blank" rel="noreferrer" style={{color:RECIPE_BRAND}}>View specification ↗</a></>}</div>}
      </div>

      {groups.map((g,gi)=>{
        const groupCount = (g.fields||[]).length;
        const groupRequired = (g.fields||[]).filter(f=>f.targetCard && f.targetCard.startsWith('1')).length;
        const offset = groupOffsets[gi] || 0;
        return (
          <div key={gi} className="mapping-group">
            <div className="mapping-group-header">
              <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
                <span style={{fontSize:10.5,fontWeight:800,color:'var(--text3)',background:'var(--surface3)',border:'1px solid var(--border)',borderRadius:6,padding:'1px 7px',fontFamily:'ui-monospace,monospace'}}>{gi+1}/{groups.length}</span>
                <div className="mapping-group-name">{g.name}</div>
                <span style={{fontSize:10.5,fontWeight:700,color:RECIPE_BRAND,background:RECIPE_BRAND_TINT,border:'1px solid rgba(233,29,65,.32)',borderRadius:10,padding:'1px 8px'}}>{groupCount} field{groupCount===1?'':'s'}</span>
                {groupRequired>0 && <span style={{fontSize:10.5,fontWeight:700,color:'#dc2626',background:'rgba(220,38,38,.08)',border:'1px solid rgba(220,38,38,.25)',borderRadius:10,padding:'1px 8px'}}>{groupRequired} required</span>}
              </div>
              {g.description && <div className="mapping-group-desc" style={{marginTop:5}}>{g.description}</div>}
            </div>
            <div style={{overflowX:'auto'}}>
              <table className="mapping-table">
                <thead>
                  <tr>
                    <th style={{width:48,textAlign:'center'}}>#</th>
                    <th style={{width:'24%'}}>Target</th>
                    <th style={{width:9}}>Card</th>
                    <th style={{width:'24%'}}>Source</th>
                    <th style={{width:'18%'}}>Transform</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {(g.fields||[]).map((f,fi)=>{
                    const required=f.targetCard && f.targetCard.startsWith('1');
                    return(
                      <tr key={fi}>
                        {/* Per-group serial · global serial on hover via title */}
                        <td style={{textAlign:'center',width:48,verticalAlign:'top'}} title={`Field ${offset+fi+1} of ${totalFields} overall`}>
                          <div style={{fontFamily:'ui-monospace,monospace',fontSize:11,fontWeight:700,color:'var(--text2)',background:'var(--surface3)',border:'1px solid var(--border)',borderRadius:6,padding:'2px 4px',display:'inline-block',minWidth:24,lineHeight:1.3}}>{fi+1}</div>
                          <div style={{fontSize:9,color:'var(--text3)',marginTop:3,fontFamily:'ui-monospace,monospace'}}>#{offset+fi+1}</div>
                        </td>
                        <td>
                          <div className="mapping-target">{f.target}</div>
                          <div style={{fontSize:11,color:'var(--text2)',marginTop:2}}>{f.targetName}</div>
                          <div style={{fontSize:10.5,color:'var(--text3)',marginTop:1}}>{f.targetType}</div>
                        </td>
                        <td><span className={`mapping-card${required?' req':''}`}>{f.targetCard||'—'}</span></td>
                        <td>
                          <div className="mapping-source">{f.source}</div>
                          {f.sourceApi && <div style={{fontSize:10.5,color:'var(--text3)',marginTop:2,fontFamily:'ui-monospace,monospace'}}>{f.sourceApi}</div>}
                          {f.sourceTable && <div style={{fontSize:10.5,color:'var(--text3)',marginTop:1,fontFamily:'ui-monospace,monospace'}}>tbl: {f.sourceTable}</div>}
                        </td>
                        <td><span className="mapping-transform">{f.transform||'—'}</span></td>
                        <td><span className="mapping-notes">{f.notes||''}</span></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* ── Recipe Documentation tab — markdown viewer with sidebar navigator ── */
function RecipeDocs({recipe, docKey, setDocKey, docBody, docLoading}){
  const docs=recipe.docs||{};
  const labels={overview:'Overview',prerequisites:'Prerequisites',install:'Install Guide','pint-ae-fusion-mapping':'PINT AE → Fusion Mapping','fusion-configuration-checklist':'Fusion Config Checklist',troubleshooting:'Troubleshooting',changelog:'Changelog'};
  const html=React.useMemo(()=>{
    if(!docBody) return '';
    try{ return window.marked ? window.marked.parse(docBody) : docBody; }
    catch(e){ return docBody; }
  },[docBody]);

  return(
    <div style={{display:'grid',gridTemplateColumns:'200px 1fr',gap:20,minHeight:400}}>
      <div style={{borderRight:'1px solid var(--border)',paddingRight:14}}>
        <div style={{fontSize:11,fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.6px',marginBottom:10}}>Sections</div>
        {Object.keys(docs).map(k=>(
          <button key={k} onClick={()=>setDocKey(k)}
            style={{
              display:'block',width:'100%',textAlign:'left',padding:'7px 10px',marginBottom:4,
              borderRadius:7,border:'none',cursor:'pointer',fontSize:12.5,fontWeight:600,
              background:docKey===k?RECIPE_BRAND_TINT:'transparent',
              color:docKey===k?RECIPE_BRAND:'var(--text2)'
            }}>
            {labels[k]||k}
          </button>
        ))}
      </div>
      <div className="markdown-body" style={{minWidth:0}}>
        {docLoading?<div style={{color:'var(--text3)'}}>Loading…</div>:
         <div dangerouslySetInnerHTML={{__html:html}}/>}
      </div>
    </div>
  );
}

/* ── Recipe Install summary tab — quick view, click-through to wizard ── */
function RecipeInstallSummary({recipe, onLaunch, accent=RECIPE_BRAND}){
  const steps=[
    ...((recipe.connections||[]).map((slot,i)=>({n:i+1,title:slot.label,desc:slot.fieldsHint || slot.description}))),
    ...(((recipe.schedule||{}).configurable)?[{n:(recipe.connections||[]).length+1,title:'Schedule',desc:`Override or accept the default — ${((recipe.schedule||{}).displayDefault||'').toLowerCase()}`}]:[]),
    {n:(recipe.connections||[]).length+((recipe.schedule||{}).configurable?2:1),title:'Review & install',desc:'Confirm the summary and click Install. Records land in DRAFT — nothing runs until you click Activate.'}
  ];
  return(
    <div style={{maxWidth:760,margin:'0 auto'}}>
      <div className="r-card" style={{background:`linear-gradient(135deg, ${accent}10, ${accent}04)`,borderColor:accent+'40',marginBottom:20}}>
        <div className="r-card-pad" style={{display:'flex',alignItems:'center',gap:18}}>
          <div style={{flex:1}}>
            <div className="r-section-title" style={{color:accent,marginBottom:6,display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="erp" size={14} color={accent}/> Ready to install?</div>
            <div style={{fontSize:13,color:'var(--text2)',lineHeight:1.6}}>The wizard takes about <strong>2 minutes</strong> for first-time installers — pick or create the source / target connections, customise the schedule, review, install. Records are created in DRAFT — nothing runs until you click Activate.</div>
          </div>
          <button className="recipe-cta" style={{background:accent,color:'#fff'}} onClick={onLaunch}>
            <RecipeIcon kind="install" size={14} color="#fff"/><span>Launch wizard</span>
          </button>
        </div>
      </div>

      <div className="r-section-title" style={{fontSize:14,marginBottom:12,display:'inline-flex',alignItems:'center',gap:8}}><RecipeIcon kind="docs" size={14}/> What you'll be asked for</div>
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {steps.map(s=>(
          <div key={s.n} className="r-card">
            <div className="r-card-pad" style={{padding:'14px 16px',display:'flex',alignItems:'flex-start',gap:14}}>
              <div style={{flex:'0 0 32px',width:32,height:32,borderRadius:'50%',background:accent+'18',color:accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800}}>{s.n}</div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,fontSize:13.5}}>{s.title}</div>
                <div style={{fontSize:12.5,color:'var(--text2)',marginTop:4,lineHeight:1.55}}>{s.desc}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Recipe Install Wizard — 3 steps ──────────────────────────────────── */
/* ============================================================================
 * RECIPE INSTALL WIZARD — 3-step guided flow
 *
 * Step 1: Connection slots — each slot can reuse an existing connection or
 *         create a new one. Adapter-aware visuals (Fusion vs ASP get distinct
 *         icons / tints / fields).
 * Step 2: Schedule (with one-click cron presets) + Project assignment.
 * Step 3: Review & install — visual summary, then a green Install button.
 *
 * The whole wizard inherits the recipe's accent color via CSS custom
 * properties so a v1.1 recipe with a teal accent automatically themes the
 * wizard the same way.
 * ============================================================================ */
function RecipeInstallWizard({recipe, onClose, onInstalled, showToast}){
  const accent = RECIPE_BRAND;
  const accentTint = 'rgba(233,29,65,.15)';
  const accent2 = RECIPE_BRAND_2;

  const [step,setStep]=useState(1);
  const [conns,setConns]=useState([]);
  const [projects,setProjects]=useState([]);
  const [slotState,setSlotState]=useState(()=>{
    const s={};
    (recipe.connections||[]).forEach(slot=>{
      s[slot.slot]={mode:'new', existingId:'', showSecret:false, payload:{
        name:'', description:'', adapter:slot.adapter, status:'DRAFT',
        authType:slot.adapter==='oracle-fusion'?'BASIC':'OAUTH2_CLIENT_CREDENTIALS',
        basePath:'', username:'', password:'',
        clientId:'', clientSecret:'', tokenUrl:'', scope:''
      }};
    });
    return s;
  });
  const [schedule,setSchedule]=useState((recipe.schedule||{}).defaultCron||'');
  const [projectId,setProjectId]=useState('');
  const [installing,setInstalling]=useState(false);

  useEffect(()=>{
    Promise.all([
      API('GET','/api/connections').catch(()=>[]),
      API('GET','/api/projects').catch(()=>[])
    ]).then(([c,p])=>{setConns(c);setProjects(p);});
  },[]);

  const setSlot=(slot,patch)=>setSlotState(prev=>({...prev,[slot]:{...prev[slot],...patch}}));
  const setSlotPayload=(slot,k,v)=>setSlotState(prev=>({...prev,[slot]:{...prev[slot],payload:{...prev[slot].payload,[k]:v}}}));
  const slots=recipe.connections||[];

  // Per-slot completeness — drives the green check chip and Next-button gate
  const slotComplete=(slot)=>{
    const s=slotState[slot.slot];
    if(!s) return !slot.required;
    if(s.mode==='existing') return !!s.existingId;
    if(s.mode==='new') return !!s.payload.name && !!s.payload.basePath;
    return !slot.required;
  };
  const canProceedStep1=slots.every(slotComplete);

  const submit=async()=>{
    setInstalling(true);
    try{
      const body={connections:{}, newConnections:{}, schedule:schedule||undefined, projectId:projectId||undefined};
      slots.forEach(slot=>{
        const s=slotState[slot.slot];
        if(s.mode==='existing') body.connections[slot.slot]=s.existingId;
        else body.newConnections[slot.slot]=s.payload;
      });
      const res=await API('POST',`/api/recipes/${recipe.id}/install`,body);
      onInstalled(res);
    }catch(e){ showToast('Install failed: '+e.message,'error'); }
    finally{ setInstalling(false); }
  };

  // Adapter-specific visual identity for slot cards
  const adapterVisuals = (adapter) => {
    if (adapter==='oracle-fusion') return {icon:<RecipeIcon kind="flow" size={14} color="#ea580c"/>, tint:'rgba(234,88,12,.06)', bg:'rgba(234,88,12,.12)', color:'#ea580c'};
    if (adapter==='taxlab-asp')    return {icon:<RecipeIcon kind="link" size={14} color={accent}/>, tint:accent+'0c', bg:accent+'1f', color:accent};
    return {icon:<RecipeIcon kind="plug" size={14} color={accent}/>, tint:accent+'0c', bg:accent+'1f', color:accent};
  };

  // Cron presets — most operators want one of these, not to type Quartz from scratch
  const CRON_PRESETS = [
    {label:'Every 5 minutes',     expr:'0 */5 * * * ?'},
    {label:'Every 15 minutes',    expr:'0 */15 * * * ?'},
    {label:'Every 30 minutes',    expr:'0 */30 * * * ?'},
    {label:'Hourly on the hour',  expr:'0 0 * * * ?'},
    {label:'Daily at 02:00',      expr:'0 0 2 * * ?'},
    {label:'Business hrs (Mon–Fri)', expr:'0 0 9-18 ? * MON-FRI'},
  ];

  return(
    <div className="modal-overlay" style={{zIndex:200}} onClick={onClose}>
      <div className="modal-content iw-modal" onClick={e=>e.stopPropagation()}
           style={{'--iw-accent':accent,'--iw-accent-2':accent2,'--iw-accent-tint':accentTint}}>

        {/* HEADER — calm + on-brand, with a thin gradient accent strip on top */}
        <div className="iw-header">
          <div className="iw-header-icon"><RecipeIcon kind="install" size={18} color="#fff"/></div>
          <div className="iw-header-meta">
            <div className="iw-header-eyebrow">Install Accelerator</div>
            <div className="iw-header-title">{recipe.name}</div>
            <div className="iw-header-sub">v{recipe.version} · {recipe.publisher} · 2-min setup</div>
          </div>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close"><CloseIcon size={16}/></button>
        </div>

        {/* STEP INDICATOR — connector lines turn green as steps complete */}
        <div className="iw-stepper">
          {[
            {n:1,label:'Connections'},
            {n:2,label:'Schedule & Project'},
            {n:3,label:'Review & Install'}
          ].map((s,idx,arr)=>(
            <React.Fragment key={s.n}>
              <div className={`iw-step${step===s.n?' active':step>s.n?' done':''}`}>
                <div className="iw-step-num">{step>s.n?'✓':s.n}</div>
                <span className="iw-step-label">{s.label}</span>
              </div>
              {idx<arr.length-1 && <div className={`iw-step-divider${step>s.n?' done':step===s.n?' partial':''}`}/>}
            </React.Fragment>
          ))}
        </div>

        {/* BODY */}
        <div className="iw-body">
          <div className="iw-body-inner">
            {step===1 && (
              <div>
                <div className="iw-intro">Each slot below can reuse an existing connection or create a new one inline. Reusing an existing connection means a future credential rotation flows through to every accelerator that shares it — exactly one place to update.</div>
                {slots.map(slot=>{
                  const s=slotState[slot.slot];
                  const matchingConns=conns.filter(c=>c.adapter===slot.adapter);
                  const v=adapterVisuals(slot.adapter);
                  const complete=slotComplete(slot);
                  return(
                    <div key={slot.slot} className={`iw-slot${complete?' complete':''}`}>
                      <div className="iw-slot-head" style={{'--slot-tint':v.tint}}>
                        <div className="iw-slot-icon" style={{'--slot-bg':v.bg,'--slot-color':v.color}}>{v.icon}</div>
                        <div style={{flex:1,minWidth:0}}>
                          <div className="iw-slot-title">
                            {slot.label}
                            <span className="iw-slot-pill">{slot.adapter}</span>
                            {slot.required && <span className="iw-slot-required">REQUIRED</span>}
                          </div>
                          <div className="iw-slot-desc">{slot.description}</div>
                        </div>
                        {complete && <div className="iw-slot-status">✓ Ready</div>}
                      </div>

                      <div className="iw-slot-body">
                        <div className="iw-mode-toggle">
                          <button type="button" className={`iw-mode-btn${s.mode==='existing'?' active':''}`}
                                  onClick={()=>setSlot(slot.slot,{mode:'existing'})}>
                            <RecipeIcon kind="reuse" size={13}/><span>Reuse existing</span><span className="count">{matchingConns.length}</span>
                          </button>
                          <button type="button" className={`iw-mode-btn${s.mode==='new'?' active':''}`}
                                  onClick={()=>setSlot(slot.slot,{mode:'new'})}>
                            <RecipeIcon kind="spark" size={13}/><span>Create new</span>
                          </button>
                        </div>

                        {s.mode==='existing' ? (
                          matchingConns.length===0 ?
                            <div style={{fontSize:12,color:'var(--text3)',padding:'10px 12px',background:'var(--surface2)',border:'1px dashed var(--border2)',borderRadius:8}}>
                              No existing connections of type <code style={{fontFamily:'ui-monospace,monospace'}}>{slot.adapter}</code> in this workspace yet — switch to <strong>Create new</strong>.
                            </div>
                          :
                            <div className="iw-field full">
                              <label className="iw-field-label">Pick a connection <span className="req">*</span></label>
                              <select className="iw-field-input" value={s.existingId} onChange={e=>setSlot(slot.slot,{existingId:e.target.value})}>
                                <option value="">— Select —</option>
                                {matchingConns.map(c=><option key={c.id} value={c.id}>{c.name}{c.status?' · '+c.status:''}</option>)}
                              </select>
                            </div>
                        ) : (
                          <div className="iw-field-grid">
                            <div className="iw-field">
                              <label className="iw-field-label">Connection name <span className="req">*</span></label>
                              <input className="iw-field-input" value={s.payload.name} onChange={e=>setSlotPayload(slot.slot,'name',e.target.value)} placeholder={slot.adapter==='oracle-fusion'?'Fusion PROD':'TaxLab ASP PROD'}/>
                            </div>
                            <div className="iw-field">
                              <label className="iw-field-label">Base URL <span className="req">*</span></label>
                              <input className="iw-field-input" value={s.payload.basePath} onChange={e=>setSlotPayload(slot.slot,'basePath',e.target.value)} placeholder={slot.adapter==='oracle-fusion'?'https://yourpod.fa.us2.oraclecloud.com':'https://api.taxlab.ae'}/>
                            </div>
                            {slot.adapter==='oracle-fusion' ? <>
                              <div className="iw-field">
                                <label className="iw-field-label">Username</label>
                                <input className="iw-field-input" value={s.payload.username} onChange={e=>setSlotPayload(slot.slot,'username',e.target.value)} placeholder="svc_taxlab_integration"/>
                              </div>
                              <div className="iw-field">
                                <label className="iw-field-label">Password</label>
                                <div className="iw-field-secret">
                                  <input className="iw-field-input secret" type={s.showSecret?'text':'password'} value={s.payload.password} onChange={e=>setSlotPayload(slot.slot,'password',e.target.value)}/>
                                  <button type="button" className="eye" onClick={()=>setSlot(slot.slot,{showSecret:!s.showSecret})} title={s.showSecret?'Hide':'Show'}>{s.showSecret?<RecipeIcon kind="eyeOff" size={14}/>:<RecipeIcon kind="eye" size={14}/>}</button>
                                </div>
                              </div>
                              <div className="iw-field full">
                                <div className="iw-field-help">Use a dedicated service account with <code>BI Consumer</code>, <code>Customer Account Inquiry</code>, and <code>Edit Receivables Transaction</code> roles.</div>
                              </div>
                            </> : <>
                              <div className="iw-field">
                                <label className="iw-field-label">Client ID</label>
                                <input className="iw-field-input" value={s.payload.clientId} onChange={e=>setSlotPayload(slot.slot,'clientId',e.target.value)}/>
                              </div>
                              <div className="iw-field">
                                <label className="iw-field-label">Client Secret</label>
                                <div className="iw-field-secret">
                                  <input className="iw-field-input secret" type={s.showSecret?'text':'password'} value={s.payload.clientSecret} onChange={e=>setSlotPayload(slot.slot,'clientSecret',e.target.value)}/>
                                  <button type="button" className="eye" onClick={()=>setSlot(slot.slot,{showSecret:!s.showSecret})} title={s.showSecret?'Hide':'Show'}>{s.showSecret?<RecipeIcon kind="eyeOff" size={14}/>:<RecipeIcon kind="eye" size={14}/>}</button>
                                </div>
                              </div>
                              <div className="iw-field">
                                <label className="iw-field-label">Token URL</label>
                                <input className="iw-field-input" value={s.payload.tokenUrl} onChange={e=>setSlotPayload(slot.slot,'tokenUrl',e.target.value)} placeholder="https://api.taxlab.ae/oauth/token"/>
                              </div>
                              <div className="iw-field">
                                <label className="iw-field-label">Scope</label>
                                <input className="iw-field-input" value={s.payload.scope} onChange={e=>setSlotPayload(slot.slot,'scope',e.target.value)} placeholder="invoices:submit invoices:status"/>
                              </div>
                            </>}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {step===2 && (
              <div>
                <div className="iw-intro">The accelerator ships with a sensible default schedule. Pick a preset below or type a custom Quartz cron expression.</div>

                {(recipe.schedule||{}).configurable && (
                  <div className="iw-slot" style={{marginBottom:14}}>
                    <div className="iw-slot-head" style={{'--slot-tint':accent+'0c'}}>
                      <div className="iw-slot-icon" style={{'--slot-bg':accent+'1f','--slot-color':accent}}><RecipeIcon kind="clock" size={14} color={accent}/></div>
                      <div style={{flex:1}}>
                        <div className="iw-slot-title">Schedule</div>
                        <div className="iw-slot-desc">When the integration polls / fires</div>
                      </div>
                    </div>
                    <div className="iw-slot-body">
                      <div className="iw-field full">
                        <label className="iw-field-label">Cron expression</label>
                        <input className="iw-field-input" style={{fontFamily:'ui-monospace,monospace'}} value={schedule} onChange={e=>setSchedule(e.target.value)}/>
                        <div className="iw-field-help">Quartz format · <code>sec min hour day month day-of-week</code></div>
                      </div>
                      <div style={{marginTop:8}}>
                        <div style={{fontSize:11,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.5px',marginBottom:6}}>Quick presets</div>
                        <div className="iw-cron-suggest">
                          {CRON_PRESETS.map(p=>(
                            <button key={p.expr} type="button" className={`iw-cron-pill${schedule===p.expr?' active':''}`} onClick={()=>setSchedule(p.expr)}>
                              <span className="label">{p.label}</span>
                              <span className="expr">{p.expr}</span>
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="iw-slot">
                  <div className="iw-slot-head" style={{'--slot-tint':RECIPE_BRAND_SOFT}}>
                    <div className="iw-slot-icon" style={{'--slot-bg':RECIPE_BRAND_TINT,'--slot-color':RECIPE_BRAND}}><RecipeIcon kind="folder" size={14} color={RECIPE_BRAND}/></div>
                    <div style={{flex:1}}>
                      <div className="iw-slot-title">Project <span style={{fontWeight:500,color:'var(--text3)',fontSize:11}}>(optional)</span></div>
                      <div className="iw-slot-desc">Group the integration in the Projects view and write its YAML under <code style={{fontFamily:'ui-monospace,monospace'}}>data/routes/{'{slug}'}/</code></div>
                    </div>
                  </div>
                  <div className="iw-slot-body">
                    <div className="iw-field full">
                      <select className="iw-field-input" value={projectId} onChange={e=>setProjectId(e.target.value)}>
                        <option value="">— No project (orphan) —</option>
                        {projects.map(p=><option key={p.id} value={p.id}>{p.name} ({p.slug})</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {step===3 && (
              <div>
                <div className="iw-intro">Final check — these are the records about to be created. Nothing runs until you click Activate on the integration afterwards.</div>

                <div className="iw-summary-card">
                  <div className="iw-summary-row">
                    <span className="k">Accelerator</span>
                    <span className="v">{recipe.name} · v{recipe.version}</span>
                  </div>
                  {slots.map(slot=>{
                    const s=slotState[slot.slot];
                    const summary = s.mode==='existing'
                      ? ((conns.find(c=>c.id===s.existingId)||{}).name||'(?)') + '  ·  reused'
                      : '"' + (s.payload.name||'unnamed') + '"  ·  new';
                    return (
                      <div key={slot.slot} className="iw-summary-row">
                        <span className="k">{slot.label}</span>
                        <span className="v">{summary}</span>
                      </div>
                    );
                  })}
                  <div className="iw-summary-row">
                    <span className="k">Integrations</span>
                    <span className="v">{(recipe.integrations||[]).length} · created in DRAFT</span>
                  </div>
                  <div className="iw-summary-row">
                    <span className="k">Lookups</span>
                    <span className="v">{(recipe.lookups||[]).length}</span>
                  </div>
                  <div className="iw-summary-row">
                    <span className="k">Schedule</span>
                    <span className="v" style={{fontFamily:'ui-monospace,monospace'}}>{schedule||(recipe.schedule||{}).defaultCron||'—'}</span>
                  </div>
                  <div className="iw-summary-row">
                    <span className="k">Project</span>
                    <span className="v">{projectId?((projects.find(p=>p.id===projectId)||{}).name||'?'):'(unassigned)'}</span>
                  </div>
                </div>

                <div className="iw-warn-card">
                  The integration is installed in <strong>DRAFT</strong> status. It will not poll Fusion or submit to ASP until you click <strong>Activate</strong> on the Integrations page.
                </div>
              </div>
            )}
          </div>
        </div>

        {/* FOOTER — sticky, with helpful hint per step */}
        <div className="iw-footer">
          {step>1 && <button className="btn btn-ghost btn-sm" onClick={()=>setStep(step-1)} disabled={installing}>← Back</button>}
          <div className="iw-footer-hint">
            {step===1 && (canProceedStep1 ? `All ${slots.length} connection${slots.length===1?'':'s'} ready` : `Complete ${slots.filter(s=>!slotComplete(s)).length} of ${slots.length} connection${slots.length===1?'':'s'}`)}
            {step===2 && ((recipe.schedule||{}).configurable ? 'Adjust the schedule or accept the default' : 'Pick a project (optional) and continue')}
            {step===3 && 'Ready to install — this creates records but activates nothing'}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={onClose} disabled={installing}>Cancel</button>
          {step<3 && <button className="iw-cta" onClick={()=>setStep(step+1)} disabled={step===1 && !canProceedStep1}>
            Next <span>→</span>
          </button>}
          {step===3 && <button className="iw-cta success" onClick={submit} disabled={installing}>
            {installing?<><Spinner/><span>Installing…</span></>:<><RecipeIcon kind="install" size={14} color="#fff"/><span>Install Accelerator</span></>}
          </button>}
        </div>
      </div>
    </div>
  );
}